import { Effect } from "./effect.model";
import { OpacityEffect, PositionEffect, ScaleEffect } from "./effectsType.model";


export class LayerData {
    id: string;
    name: string = ""
    order: number;
    type: string;
    size_w: number;
    size_h: number;
    start_time: number;
    end_time: number;
    parent_id: string | null;
    effects: Effect[] = [];
    path: number[] = []
    visible: boolean = true;
    children: any[] = [];
    dirty: boolean = false;

    constructor(data?: Partial<LayerData>) {
        this.id = data?.id?.toString() || crypto.randomUUID();
        this.name = data?.name || "New Layer"
        this.type = data?.type || "composition";
        this.visible = data?.visible === undefined ? true : data.visible;
        this.size_w = data?.size_w ?? 100;
        this.size_h = data?.size_h ?? 100;
        this.order = data?.order ?? 0;
        this.start_time = data?.start_time ?? 0;
        this.end_time = data?.end_time ?? 10;
        this.parent_id = data?.parent_id || null;
        this.path = data?.path || [];
        this.effects = data?.effects || [];
        this.children = data?.children || [];

        if (this.type !== "audio") {
            const requiredVideoEffects = ["opacity", "scale", "position"]
            requiredVideoEffects.forEach((requiredVideoEffects) => {
                if (
                    this.effects.findIndex(
                        (effect) => effect.type === requiredVideoEffects
                    ) < 0
                ) {
                    let newEffect;
                    switch (requiredVideoEffects) {
                        case "opacity":
                            newEffect = new OpacityEffect({});
                            break;
                        case "scale":
                            newEffect = new ScaleEffect({});
                            break;
                        case "position":
                            newEffect = new PositionEffect({});
                            break;
                        default:
                            newEffect = new Effect({ type: requiredVideoEffects });
                            break;
                    }
                    this.effects.push(newEffect);
                }
            });
        }
    }
}